import TopSideBar from "../../components/TopSideBar";
import PageContainer from "../../components/common/PageContainer";
import UserPasswordChange from "../../components/UserPasswordChange";
import { PADDING_BASE } from "../../assets/Styles";
import TitlebarAction from "../../components/common/TitlebarActions";
import Copyright from "../../components/common/Copyright";
import { Box } from "@mui/material";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import { Link } from "react-router-dom";

export default function UserPasswordChangePage({ setBlockScreen }: any) {

  return (<>
    <TopSideBar currentSection="users" disableProjectSelector hideProjectSelector />
    <PageContainer>

      <Box paddingBottom={PADDING_BASE}>
        <Breadcrumbs
          pathlist={[
            <Link className="breadcrumbs-nav__link" to="/tickets/listing">Home</Link>,
            'Cambio de Contraseña'
          ]} />
      </Box>

      <TitlebarAction title='Cambiar Contraseña' />

      <UserPasswordChange setBlockScreen={setBlockScreen} />

      <Copyright />

    </PageContainer>
  </>)
}